import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  Home, 
  Shield, 
  Package, 
  Wifi, 
  Brain, 
  BarChart3, 
  FileText, 
  Settings,
  ChevronLeft,
  ChevronRight,
  User,
  HelpCircle
} from 'lucide-react';

const Sidebar = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();

  const menuItems = [
    { path: '/dashboard', icon: Home, label: 'Dashboard' },
    { path: '/compliance', icon: Shield, label: 'Compliance' },
    { path: '/atf-compliance', icon: Shield, label: 'ATF Compliance' },
    { path: '/customer-entry', icon: User, label: 'Customer Entry' },
    { path: '/inventory', icon: Package, label: 'Inventory' },
    { path: '/iot-devices', icon: Wifi, label: 'IoT Devices' },
    { path: '/ai-learning-control', icon: Brain, label: 'AI Learning' },
    { path: '/compliance-dashboard', icon: BarChart3, label: 'Compliance Dashboard' },
    { path: '/compliance-reporting', icon: FileText, label: 'Compliance Reporting' },
    { path: '/support', icon: HelpCircle, label: 'Support' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.div
      initial={{ width: 250 }}
      animate={{ width: isCollapsed ? 70 : 250 }}
      className="bg-gray-800 border-r border-gray-700 h-screen sticky top-0"
    >
      <div className="flex flex-col h-full">
        {/* Toggle Button */}
        <div className="flex justify-end p-4">
          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            className="p-2 rounded-lg bg-gray-700 hover:bg-gray-600 transition-colors"
          >
            {isCollapsed ? <ChevronRight className="w-4 h-4" /> : <ChevronLeft className="w-4 h-4" />}
          </button>
        </div>

        {/* Navigation Menu */}
        <nav className="flex-1 px-4">
          <ul className="space-y-2">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center px-3 py-2 rounded-lg transition-colors ${
                    isActive(item.path)
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                  }`}
                >
                  <item.icon className="w-5 h-5 flex-shrink-0" />
                  {!isCollapsed && (
                    <span className="ml-3 font-medium">{item.label}</span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Bottom Section */}
        <div className="p-4 border-t border-gray-700">
          <Link
            to="/settings"
            className={`flex items-center px-3 py-2 rounded-lg transition-colors ${
              isActive('/settings')
                ? 'bg-blue-600 text-white'
                : 'text-gray-300 hover:bg-gray-700 hover:text-white'
            }`}
          >
            <Settings className="w-5 h-5 flex-shrink-0" />
            {!isCollapsed && (
              <span className="ml-3 font-medium">Settings</span>
            )}
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default Sidebar;
